import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_MANAGEMENT = async () => {
  const { management } = await initializeConfig();
  return `${management}`;
};

export interface IRequestDocumentRegisterActive {
  _size: number;
  _page: number;
  orderBy: string;
  ascending: boolean;
  filter: string;
}

export interface IRequestPostDocument {
  description: string;
  maskRules: {
    maskAllowLetters: boolean;
    maskAllowNumbers: boolean;
    maskAllowSpecialCharacters: boolean;
    maskMinCharacters: number;
    maskMaxCharacters: number;
  };
}

export interface IRequestUpdateDocument {
  description: string;
  maskRules: {
    allowLetters: boolean;
    allowNumbers: boolean;
    allowSpecialCharacters: boolean;
    minCharacters: number;
    maxCharacters: number;
  };
}

export interface IRequestUpdateDocumentId {
  documentId: number;
}

export const getDocuments = async ({ _size, _page, orderBy, ascending, filter }: IRequestDocumentRegisterActive) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}documents:paginated`, { _size, _page, orderBy, ascending, filter });
};

export const saveNewDocument = async (params: IRequestPostDocument) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).post(`${baseUrlManagement}documents`, params);
};

export const deleteDocument = async (id: number) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).delete(`${baseUrlManagement}documents/?documentId=${id}`);
};

export const updateDocument = async (params: IRequestUpdateDocument, documentId: IRequestUpdateDocumentId) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).put(`${baseUrlManagement}documents/${documentId}`, params);
};

export const getDocumentById = async ({ id }) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}documents/${id}`);
};
